import { lazy, Suspense } from "react";

// Defers the TipTap editor (~840KB with prosemirror) into an async chunk —
// it's client-only, so the server renders the null fallback and the editor
// loads after hydration.
const NoteDetailImpl = lazy(() => import("./NoteDetail.impl"));

const NoteDetail = (props) => (
  <Suspense fallback={null}>
    <NoteDetailImpl {...props} />
  </Suspense>
);

export default NoteDetail;
